<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";
import type { components } from "@/types/openapi.interfaces";

import CircleCheckMarkIcon from "@/components/icons/CircleCheckMarkIcon.vue";
import CircleXMarkIcon from "@/components/icons/CircleXMarkIcon.vue";
import ClockIcon from "@/components/icons/ClockIcon.vue";

const props = defineProps<{
  status: components["schemas"]["StatusEnum"];
  class?: string;
}>();

const { data: user } = useUser();
</script>

<template>
  <div
    :class="
      twMerge(
        'flex w-fit items-center gap-3 rounded-lg border px-5 py-2 text-base leading-[110%] font-medium [&>svg]:order-first [&>svg]:size-5 [&>svg]:shrink-0',
        (status === 'declared' || status === 'user_reviewed') &&
          user?.current_mechanic !== 'lactel' &&
          'border-galbani text-galbani bg-white',
        (status === 'declared' || status === 'user_reviewed') &&
          user?.current_mechanic === 'lactel' &&
          'border-lactel-blue text-lactel-blue bg-white',
        status === 'completed' &&
          user?.current_mechanic !== 'lactel' &&
          'bg-topchef border-topchef text-galbani',
        status === 'completed' &&
          user?.current_mechanic === 'lactel' &&
          'bg-lactel-yellow border-lactel-yellow text-lactel-blue',
        status === 'filtered_analyzed' &&
          user?.current_mechanic !== 'lactel' &&
          'bg-success border-success text-white',
        status === 'filtered_analyzed' &&
          user?.current_mechanic === 'lactel' &&
          'bg-lactel-green-600 border-b-lactel-green-600 text-white',
        status === 'rejected' && 'bg-error border-error text-white',
        props.class,
      )
    "
    role="status"
  >
    <template v-if="status === 'declared'">
      <ClockIcon aria-hidden="true" />
      {{ $t("receipt.declared") }}
    </template>

    <template v-if="status === 'user_reviewed'">
      <ClockIcon aria-hidden="true" />
      {{ $t("receipt.inReview") }}
    </template>

    <template v-else-if="status === 'completed'">
      <CircleCheckMarkIcon aria-hidden="true" />
      {{ $t("receipt.completed") }}
    </template>

    <template v-else-if="status === 'rejected'">
      <CircleXMarkIcon aria-hidden="true" />
      {{ $t("receipt.rejected") }}
    </template>

    <template v-else-if="status === 'filtered_analyzed'">
      <CircleCheckMarkIcon aria-hidden="true" />
      {{ $t("receipt.analyzed") }}
    </template>
  </div>
</template>
